import logo from "../../assets/logo-1.svg";
import {
  FiHome as Home,
  FiUsers as Users,
  FiMessageSquare as MessageSquare,
  FiGrid as LayoutDashboard,
} from "react-icons/fi";
import { useEffect, useState } from "react";
import SideBar from "../sideBar";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearVenueDetails,
  getDetailsByReferenceId,
  getJoinRequestDetail,
  getUserDetails,
  getVenueDetails,
} from "store/slice/profile";
import {
  addRatingReviews,
  getConfig,
  getNotificationList,
} from "store/slice/auth";
import { Bell } from "lucide-react";
import "react-datepicker/dist/react-datepicker.css";
import { useLoginData } from "component/common/loginData";
import userImg from "../../assets/user_default.png";
import Notifications from "component/notification";
import AddRatingReview from "component/notification/addRatingReview";
import FullPageLoader from "component/ui/fullPageLoader";
import AssignedMatchDetailsDialog from "../../pages/myPosting/assignedMatchDetails";
import { CARDS_ENUMS, CARDS_NAVIGATION_ENUMS } from "helper/constant";
import { getEventDetails } from "store/slice/booking";
const navItems = [
  { name: "Home", icon: "🏠", href: "/dashboard" },
  { name: "Community", icon: "🌐", href: "/community" },
  { name: "Messages", icon: "✉️", href: "/messages" },
  { name: "My Posting", icon: "📝", href: "/my-posting" },
];

const Navbar = () => {
  const navigate = useNavigate();
  const userData = useLoginData();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userProfileData, referenceIdDetailData, joinRequestDetail } =
    useSelector((state) => state.profile);
  const { notificationData } = useSelector((state) => state.auth);
  const { configData } = useSelector((state) => state.auth);
  const [dialogData, setDialogData] = useState(null);
  const [ratingData, setRatingData] = useState({});
  const [open, setOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const redirectRegister = () => {
    navigate("/dashboard");
  };

  useEffect(() => {
    if (!userProfileData) dispatch(getUserDetails());
    if (!configData) dispatch(getConfig());
    if (!notificationData) fetchNotificationList();
  }, []);
  const fetchNotificationList = (page, search) => {
    dispatch(
      getNotificationList(
        page ?? 1,
        25,
        search ? search : searchQuery ?? "",
        setButtonLoading
      )
    );
  };

  const handleRating = () => {
    setRatingData((formData) => ({
      ...formData,
      loader: true,
    }));
    const request = {
      language: "en",
      rating: ratingData?.rating,
      description: ratingData?.description,
      reviewToUserId: ratingData?.userId,
      notificationId: ratingData?.id,
      ratingType: 3,
      cardType: ratingData?.cardType,
      cardId: ratingData?.crewId ? ratingData?.crewId : ratingData?.gameCardId,
    };
    dispatch(addRatingReviews(request, setRatingData));
  };

  const handleDetails = async (data) => {
    // venue cards details
    if (data?.cardType == CARDS_ENUMS?.VENUE && data?.cardReferenceID) {
      navigate(`card-details/card/${data?.cardReferenceID}`);
      setNotificationOpen(false);
    }
    // request match cards details
    if (data?.cardType == CARDS_ENUMS?.JOIN && data?.clubId) {
      navigate(
        `card-details/${CARDS_NAVIGATION_ENUMS[data?.cardType]}/${data?.clubId}`
      );
      setNotificationOpen(false);
    }
    // event cards details
    if (data?.cardType == CARDS_ENUMS?.EVENT && data?.eventId) {
      navigate(
        `card-details/${CARDS_NAVIGATION_ENUMS[data?.cardType]}/${
          data?.eventId
        }`
      );
      setNotificationOpen(false);
    }
    // game-on cards details
    if (data?.cardType == CARDS_ENUMS?.GAME && data?.gameCardId) {
      navigate(
        `card-details/${CARDS_NAVIGATION_ENUMS[data?.cardType]}/${
          data?.gameCardId
        }`
      );
      setNotificationOpen(false);
    }
    // service cards details
    if (data?.cardType == CARDS_ENUMS?.SERVICE && data?.crewId) {
      navigate(
        `card-details/${CARDS_NAVIGATION_ENUMS[data?.cardType]}/${data?.crewId}`
      );
      setNotificationOpen(false);
    }
  };

  return (
    <header className="bg-black fixed w-full text-white shadow-lg z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        {loading && <FullPageLoader />}
        <div
          className="flex-shrink-0 cursor-pointer"
          onClick={redirectRegister}
        >
          <img src={logo} alt="Logo" className="md:w-auto w-32" />
        </div>

        {/* Navigation */}
        <nav className="hidden md:block">
          <div className="flex items-baseline lg:space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`flex items-center px-3 py-2 hover:text-blue-400 text-md font-semibold gap-1
                  ${
                    location.pathname === item.href
                      ? "text-blue-400"
                      : "text-gray-300 hover:text-white"
                  }`}
              >
                {item?.icon} {/* <item.icon className="h-5 w-5" /> */}
                {item.name}
              </Link>
            ))}
          </div>
        </nav>

        <div className="flex items-center space-x-4">
          <button
            className="flex-shrink-0 rounded-full focus:outline-none"
            onClick={() => {
              fetchNotificationList();
              setNotificationOpen(true);
            }}
          >
            <Bell className="h-7 w-7" />
          </button>

          {/* Profile */}
          <button
            className="flex-shrink-0 rounded-full focus:outline-none border"
            onClick={() => setOpen(!open)}
          >
            <div
              style={{
                backgroundImage:
                  userData?.venueImageUrl?.length > 0
                    ? `url("${
                        userData?.venueImageUrl?.length > 0 &&
                        userData?.venueImageUrl[0]
                      }")`
                    : "linear-gradient(to bottom right, #3B82F6, #9333EA)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              className="h-9 w-9 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full font-bold text-lg flex items-center justify-center text-white shadow-xl ring-4 ring-white/10 transition-transform "
            >
              {userData?.venueImageUrl?.length > 0
                ? ""
                : userData?.name && userData?.name[0]?.toUpperCase()}
            </div>
          </button>
        </div>

        <SideBar open={open} setOpen={setOpen} className="" />
      </div>

      {/* Overlay */}
      {notificationOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => setNotificationOpen(false)}
        />
      )}

      {/* rating review  */}
      {ratingData?.isShow && (
        <AddRatingReview
          ratingData={ratingData}
          setRatingData={setRatingData}
          handleRating={handleRating}
        />
      )}
      {/* Notifications */}
      <Notifications
        notification={notificationData}
        open={notificationOpen}
        fetchNotificationList={fetchNotificationList}
        setRatingData={setRatingData}
        setNotificationOpen={setNotificationOpen}
        searchQuery={searchQuery}
        handleDetails={handleDetails}
        buttonLoading={buttonLoading}
        setButtonLoading={setButtonLoading}
        setSearchQuery={setSearchQuery}
      />
    </header>
  );
};

export default Navbar;
